exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* Override any standard vShop CSS for a custom UI build */\r\n\r\n/* Common Examples */\r\n\r\n.product-container {\r\n\tdisplay: flex;\r\n\tmin-height: 550px !important;\r\n}\r\n\r\n/* https://www.w3schools.com/colors/colors_names.asp */\r\n\r\n.highlight-colour { color: darkkhaki !important; }\r\n.warning-colour { background-color: darkkhaki !important; }\r\n\r\n.auction-colour { background-color: aquamarine !important; }\r\n\r\n.navigation-menu-item:hover {\tcolor: darkkhaki; }\r\n", ""]);

// exports
